import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

export const exportAssetRequest = (data = []) => {
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk diexport.");
    return;
  }

  const headers = [
    "No",
    "Requester",
    "User Code",
    "Position",
    "Asset Name",
    "Asset Code",
    "Serial Number",
    "Brand",
    "Model",
    "Category",
    "Request Date",
    "Assign Date",
    "Return Date",
    "Status",
    "Approval Status",
    "Approved By",
    "Notes",
  ];

  const rows = data.map((item, index) => [
    index + 1,
    item?.user?.name || "-",
    item?.user?.users_code || "-",
    item?.user?.position?.position_name || "-",
    item?.asset?.asset_name || "-",
    item?.asset?.asset_code || "-",
    item?.asset?.serial_number || "-",
    item?.asset?.brand || "-",
    item?.asset?.model || "-",
    item?.asset?.category?.name ||
      item?.asset?.category?.asset_category_name ||
      "-",
    item?.request_date ? dayjs(item.request_date).format("YYYY-MM-DD") : "-",
    item?.assign_date ? dayjs(item.assign_date).format("YYYY-MM-DD") : "-",
    item?.return_date ? dayjs(item.return_date).format("YYYY-MM-DD") : "-",
    item?.status || "-",
    item?.approval_status || "-",
    item?.approved_by_user?.name || "-",
    item?.notes || "-",
  ]);

  const worksheetData = [headers, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  ws["!cols"] = [
    { wch: 5 },
    { wch: 24 },
    { wch: 14 },
    { wch: 22 },
    { wch: 28 },
    { wch: 16 },
    { wch: 20 },
    { wch: 16 },
    { wch: 16 },
    { wch: 18 },
    { wch: 15 },
    { wch: 15 },
    { wch: 15 },
    { wch: 14 },
    { wch: 18 },
    { wch: 24 },
    { wch: 35 },
  ];

  ws["!autofilter"] = {
    ref: `A1:Q${rows.length + 1}`,
  };

  const border = {
    top: { style: "thin", color: { rgb: "000000" } },
    bottom: { style: "thin", color: { rgb: "000000" } },
    left: { style: "thin", color: { rgb: "000000" } },
    right: { style: "thin", color: { rgb: "000000" } },
  };

  headers.forEach((_, colIndex) => {
    const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });

    ws[cellRef].s = {
      font: {
        bold: true,
        color: { rgb: "FFFFFF" },
      },
      fill: {
        fgColor: { rgb: "1F4E78" },
      },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
      border,
    };
  });

  rows.forEach((_, rowIndex) => {
    headers.forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({
        r: rowIndex + 1,
        c: colIndex,
      });

      if (!ws[cellRef]) return;

      ws[cellRef].s = {
        alignment: {
          horizontal: colIndex === 0 ? "center" : "left",
          vertical: "center",
          wrapText: true,
        },
        border,
      };
    });
  });

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Asset Request");

  const wbout = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });

  saveAs(
    new Blob([wbout], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }),
    `Asset_Request_${dayjs().format("YYYY-MM-DD")}.xlsx`
  );
};